import { Typography } from '@mui/material'
import { useStyles } from './styles'

const AppVersion = () => {
  const classes = useStyles()

  return <Typography className={classes.version}>v{process.env.REACT_APP_VERSION}</Typography>
}

export { AppVersion }
